import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class UserResource extends AuthenticatedResource {
  static urlRoot = '/admin/users'

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}